import { Text, type TextStyle } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight } from '~/utils'

export const Title = styled(Text, theme => {
  const defaultFontWeight = String(
    theme.fontWeightBold
  ) as TextStyle['fontWeight']

  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      fontWeight: defaultFontWeight,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {},
  }
})
